import { Grid } from "@mui/material";
import { DateTime } from "luxon";
import { type FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Style from "./ChartOverviewModule.module.scss";

type Props = {
	startDate?: string;
	endDate?: string;
	status?: string;
	percentage?: string;
	color?: any;
	isActive: boolean;
};

export const ChartOverviewModule: FC<Props> = ({ startDate, endDate, status, percentage, color, isActive }) => {
	const { i18n } = useTranslation();

	const formatDateRange = useMemo<string>(() => {
		const startMoment = startDate ? DateTime.fromISO(startDate) : DateTime.now();
		const endMoment = endDate ? DateTime.fromISO(endDate) : DateTime.now();

		if (startMoment.month === endMoment.month) {
			return `${startMoment.toFormat("MMMM d")} - ${endMoment.toFormat("D")}`;
		}

		return `${startMoment.toFormat("MMMM d")} - ${endMoment.toFormat("MMMM d")}`;
	}, [startDate, endDate, i18n.language]);

	return (
		<div className={`${Style.container} ${isActive ? Style.active : ""}`}>
			<div className={Style.percentage}>{percentage ? `${percentage}%` : ""}</div>
			<div className={Style.wrapper}>
				<p className={Style.dates}>{formatDateRange}</p>
				<Grid
					container
					sx={{
						width: "100%",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
						flexWrap: "wrap",
					}}
				>
					<div className={Style.status}>{status}</div>
					<div className={Style.ellipse} style={{ backgroundColor: color }} />
				</Grid>
			</div>
		</div>
	);
};
